// homeWebStyles.jsx
import { StyleSheet } from 'react-native';

export default StyleSheet.create({
    container: {
        flexDirection: 'row',
        height: '100vh',
        backgroundColor: '#f5f5f5',
    },

    // Sidebar moderna com ícones e labels
    sidebarMinimal: {
        width: 120,
        backgroundColor: '#d9d9d9',
        paddingTop: 20,
        alignItems: 'center',
        height: '100vh',
    },

    sidebarLogo: {
        width: 50,
        height: 50,
        resizeMode: 'contain',
        marginBottom: 20,
    },

    menuList: {
        width: '100%',
        alignItems: 'center',
    },

    menuItem: {
        marginVertical: 12,
        alignItems: 'center',
    },

    menuIcon: {
        width: 35,
        height: 35,
        resizeMode: 'contain',
        marginBottom: 4,
    },

    menuLabel: {
        fontSize: 16,
        color: '#71727A',
        fontWeight: '600',
        textAlign: 'center',
    },

    // Conteúdo principal
    contentMinimal: {
        flexGrow: 1,
        backgroundColor: '#f5f5f5',
        paddingHorizontal: 40,
        paddingVertical: 32,
    },
    title: {
        fontSize: 22,
        fontWeight: '700',
        textAlign: 'center',
        marginBottom: 24,
        color: '#1F2024',
    },
    welcomeMinimal: {
        fontSize: 22,
        fontWeight: '600',
        color: '#333',
        marginBottom: 32,
    },

    // Grade de cards (grid responsivo)
    gridMinimal: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 24,
    },

    // Card refinado com hover/disabled
    cardMinimal: {
        width: 200,
        height: 200,
        backgroundColor: '#f5f5f5',
        borderRadius: 16,
        padding: 20,
        alignItems: 'center',
        justifyContent: 'center',
        borderWidth: 1,
        borderColor: '#ddd',
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.06,
        shadowRadius: 4,
        elevation: 2,
        cursor: 'pointer',
    },

    cardIconMinimal: {
        width: 56,
        height: 56,
        marginBottom: 12,
        resizeMode: 'contain',
    },

    cardLabelMinimal: {
        fontSize: 14,
        fontWeight: '600',
        color: '#333',
        textAlign: 'center',
    },

    cardDisabled: {
        opacity: 0.4,
        cursor: 'not-allowed',
    },
});
